import { createTheme } from "@mui/material/styles";
import { optionKey, smartFilter } from "../utility/smartSearch";

const theme = createTheme({
  components: {
    // Every Autocomplete in the app searches across fields — vendors by
    // name / ID / GSTIN, products by name / barcode / brand, users by name /
    // username / phone, brands by name / ID — not just its visible label.
    // A screen can still pass its own filterOptions (e.g. server-side search).
    MuiAutocomplete: {
      defaultProps: {
        filterOptions: smartFilter(),
        // Stable row keys: duplicate labels (brand / vendor / owner listed
        // twice) otherwise show wrong or blank rows while typing.
        getOptionKey: optionKey,
      },
    },
  },
  palette: {
    primary: {
      light: "#D2EFE3",
      main: "#000000",
    },
    secondary: {
      light: "#f5f6f9",
      main: "#152567",
    },
  },
  spacing: 10,
});

export default theme;